// Employee Modal functionality

import { Modal } from "bootstrap";

/**
 * Initialize employee modal functionality
 */
document.addEventListener("DOMContentLoaded", function () {
	const employeeInfoButtons = document.querySelectorAll(".employee-list__info[data-bs-toggle='modal']");
	const modalElement = document.getElementById("employeeModal");
	
	if (!modalElement || employeeInfoButtons.length === 0) {
		return;
	}

	const modal = new Modal(modalElement);

	// Add click event listeners to all employee info buttons
	employeeInfoButtons.forEach((button) => {
		button.addEventListener("click", function (e) {
			e.preventDefault();
			
			// Get data attributes from the clicked button
			const employeeName = this.getAttribute("data-employee-name") || "";
			const employeePosition = this.getAttribute("data-employee-position") || "";
			const employeeEmail = this.getAttribute("data-employee-email") || "";
			const employeePhone = this.getAttribute("data-employee-phone") || "";
			const employeeMobile = this.getAttribute("data-employee-mobile") || "";
			const employeeImage = this.getAttribute("data-employee-image") || "";
			const employeeImageAlt = this.getAttribute("data-employee-image-alt") || "";
			const employeeDescription = this.getAttribute("data-employee-description") || "";

			// Populate modal with employee data
			populateModal({
				name: employeeName,
				position: employeePosition,
				email: employeeEmail,
				phone: employeePhone,
				mobile: employeeMobile,
				image: employeeImage,
				imageAlt: employeeImageAlt,
				description: employeeDescription,
			});

			// Show the modal
			modal.show();
		});
	});

	/**
	 * Populate modal with employee data
	 */
	function populateModal(data) {
		// Set image
		const imageElement = document.getElementById("modal-employee-image");
		if (imageElement) {
			imageElement.src = data.image;
			imageElement.alt = data.imageAlt || data.name;
		}

		// Set name
		const nameElement = document.getElementById("modal-employee-name");
		if (nameElement) {
			nameElement.textContent = data.name;
		}

		// Set position
		const positionElement = document.getElementById("modal-employee-position");
		if (positionElement) {
			positionElement.textContent = data.position;
		}

		// Set description
		const descriptionElement = document.getElementById("modal-employee-description");
		if (descriptionElement) {
			descriptionElement.textContent = data.description;
		}

		// Set email
		const emailContainer = document.getElementById("modal-employee-email-container");
		const emailLink = document.getElementById("modal-employee-email");
		const emailText = document.getElementById("modal-employee-email-text");
		if (data.email) {
			if (emailContainer) emailContainer.style.display = "block";
			if (emailLink) {
				emailLink.href = `mailto:${data.email}`;
			}
			if (emailText) {
				emailText.textContent = data.email;
			}
		} else {
			if (emailContainer) emailContainer.style.display = "none";
		}

		// Set phone
		const phoneContainer = document.getElementById("modal-employee-phone-container");
		const phoneLink = document.getElementById("modal-employee-phone");
		const phoneText = document.getElementById("modal-employee-phone-text");
		if (data.phone) {
			if (phoneContainer) phoneContainer.style.display = "block";
			if (phoneLink) {
				phoneLink.href = `tel:${data.phone}`;
			}
			if (phoneText) {
				phoneText.textContent = data.phone;
			}
		} else {
			if (phoneContainer) phoneContainer.style.display = "none";
		}

		// Set mobile
		const mobileContainer = document.getElementById("modal-employee-mobile-container");
		const mobileLink = document.getElementById("modal-employee-mobile");
		const mobileText = document.getElementById("modal-employee-mobile-text");
		if (data.mobile) {
			if (mobileContainer) mobileContainer.style.display = "block";
			if (mobileLink) {
				mobileLink.href = `tel:${data.mobile}`;
			}
			if (mobileText) {
				mobileText.textContent = data.mobile;
			}
		} else {
			if (mobileContainer) mobileContainer.style.display = "none";
		}
	}
});







